import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Pagination,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import DocCard from "./documentCard";
import apiClient from "../../../services/apiClient";

const ViewSubsectionDocuments = ({
  fetchContentData,
  subsection,
  section,
  language,
}) => {
  const [documents, setDocuments] = useState([]);
  const [total_pages, setTotalPages] = useState(1);
  const [gadTypes, setGadTypes] = useState([]);
  const [filters, setFilters] = useState({
    search: "",
    code_number: "",
    from_date: "",
    to_date: "",
    master_gr: "ALL",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState(filters);

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        language,
        section,
        subsection: subsection.subsection,
        filter: {
          ...appliedFilters,
          page_num: currentPage,
        },
      };
      try {
        const response = await fetchContentData(params);
        setDocuments(response.data || []);
        setTotalPages(response.total_pages || 1);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };
    fetchData();
  }, [subsection, section, language, appliedFilters, currentPage]);

  // Fetch GAD types from API
  useEffect(() => {
    const fetchGadTypes = async () => {
      try {
        const response = await apiClient.get("/section_page/gad_type");
        setGadTypes(response.data || []);
      } catch (error) {
        console.error("Error fetching GAD types: ", error);
        setGadTypes([]); // Set empty array on error
      }
    };
    fetchGadTypes();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleFilterSubmit = () => {
    // Set applied filters to trigger data fetch
    setAppliedFilters(filters);
    setCurrentPage(1); // Reset to the first page after applying filters
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <Box sx={{ padding: "20px" }} bgcolor={"white"}>
      <Typography
        variant="h2"
        fontWeight={"700"}
        mb={"20px"}
        textAlign={"left"}
        color="black"
      >
        {subsection.subsection}
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: "20px",
          marginBottom: "20px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <TextField
          name="search"
          value={filters.search}
          onChange={handleFilterChange}
          variant="outlined"
          placeholder="Search"
          InputProps={{
            style: {
              borderRadius: "30px",
              backgroundColor: "rgba(236, 248, 249, 1)",
            },
            endAdornment: <Search />,
          }}
          size="small"
          sx={{
            width: {
              xs: "100%",
              md: "204px",
            },
          }}
        />
        <TextField
          label="Code Number"
          name="code_number"
          value={filters.code_number}
          onChange={handleFilterChange}
          variant="outlined"
          InputProps={{
            style: {
              borderRadius: "30px",
              backgroundColor: "rgba(236, 248, 249, 1)",
            },
          }}
          size="small"
          sx={{
            width: {
              xs: "100%",
              md: "204px",
            },
          }}
        />
        <TextField
          label="From Date"
          name="from_date"
          type="date"
          value={filters.from_date}
          onChange={handleFilterChange}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          InputProps={{
            style: {
              borderRadius: "30px",
              backgroundColor: "rgba(236, 248, 249, 1)",
            },
          }}
          size="small"
          sx={{
            width: {
              xs: "100%",
              md: "204px",
            },
          }}
        />
        <TextField
          label="To Date"
          name="to_date"
          type="date"
          value={filters.to_date}
          onChange={handleFilterChange}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          InputProps={{
            style: {
              borderRadius: "30px",
              backgroundColor: "rgba(236, 248, 249, 1)",
            },
          }}
          sx={{
            width: {
              xs: "100%",
              md: "204px",
            },
          }}
          size="small"
        />
        <FormControl
          size="small"
          sx={{
            width: {
              xs: "100%",
              md: "204px",
            },
          }}
        >
          <InputLabel>Department</InputLabel>
          <Select
            name="master_gr"
            value={filters.master_gr}
            onChange={handleFilterChange}
            label="Department"
            sx={{
              borderRadius: "30px",
              backgroundColor: "rgba(236, 248, 249, 1)",
            }}
          >
            <MenuItem value="ALL">ALL</MenuItem>
            <MenuItem value="Master_gr">Master GR</MenuItem>
            {gadTypes.map((type, index) => (
              <MenuItem key={index} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFilterSubmit}
          sx={{
            width: {
              xs: "100%",
              md: "120px",
            },
            height: "48px",
            borderRadius: "10000px",
          }}
        >
          Apply Filters
        </Button>
      </Box>

      <Grid container spacing={3} justifyContent="center">
        {documents.map((doc, index) => (
          <Grid item xs={4} sm={4} md={3} lg={2} key={index}>
            <DocCard doc={doc} />
          </Grid>
        ))}
      </Grid>

      <Box
        sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        <Pagination
          count={total_pages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default ViewSubsectionDocuments;
